export default {
  disclaimer: {
    summary:
      'Huomaa, että on sinun vastuullasi varmistaa, että valuutta ja verot ovat oikein kyseiselle lainkäyttöalueelle.',
    extra:
      'Tarjoamme nämä tiedot vain käyttömukavuuden vuoksi emmekä vastaa valuutan ja/tai verojen oikeellisuudesta tai niiden maksamisesta tuotteidemme osana. Tässä mainitut valuutta- ja verotiedot ovat vain tiedoksi.',
    show_more: 'Näytä lisää',
    show_less: 'Näytä vähemmän',
  },
  partner_note:
    'Nämä ovat kumppanitason oletusarvosi. Tilisi alaiset ravintolat perivät nämä arvot automaattisesti, elleivät ne ohita yksittäistä luokkaa.',
  section_title: 'Valikkotuotteiden verokannat',
  new_category_placeholder: 'Uusi luokka',
  form: {
    name: {
      label: 'Veroluokka',
    },
    default_tax_rate: {
      label: 'Oletusverokanta',
      tooltip: 'Käytetään varaveroarvona, kun alla oleva tilaustavan erityiskanta on jätetty tyhjäksi.',
    },
    pickup_tax_rate: {
      label: 'Nouto',
    },
    delivery_tax_rate: {
      label: 'Toimitus',
    },
    dine_in_tax_rate: {
      label: 'Ravintolassa',
    },
    on_site_tax_rate: {
      label: 'Pöytätilaus',
    },
    show_zero_tax_in_summary: {
      label: 'Näytä 0 % vero tilausyhteenvedossa',
    },
  },
  buttons: {
    add_category: 'Lisää uusi veroluokka',
    cancel: 'Peruuta',
    save: 'Tallenna',
    confirm: 'Poista',
    delete: 'Poista luokka',
    reset: 'Palauta peritty arvo',
  },
  delete_confirm: {
    title: 'Poistetaanko tämä veroluokka?',
    description: 'Tätä ei voi perua.',
  },
  scope_labels: {
    region: 'Koko alue',
    partner: 'Koko kumppanuus',
    restaurant: 'Koko ravintola',
  },
  confirm_modal: {
    title: {
      fork: 'Tehdäänkö tästä ravintolan oma luokka?',
      owned: 'Otetaanko uudet verokannat käyttöön?',
      reset: 'Palataanko periytyvään luokkaan?',
    },
    affected_one: '{{count}} tuote tai luokka on tällä hetkellä linkitetty ja siihen sovelletaan uusia verokantoja.',
    affected_other:
      '{{count}} tuotetta ja kategoriaa on tällä hetkellä linkitetty ja niihin sovelletaan uusia verokantoja.',
    affected_settings_one:
      '{{count}} tuote tai kategoria on tällä hetkellä linkitetty ja käyttää päivitettyjä asetuksia.',
    affected_settings_other:
      '{{count}} tuotetta ja kategoriaa on tällä hetkellä linkitetty ja käyttää päivitettyjä asetuksia.',
    restaurants_one: 'Se on {{count}} ravintola.',
    restaurants_other: 'Se on {{count}} ravintolaa.',
    acknowledge:
      'Ymmärrän, että tämän vahvistaminen muuttaa verokategorian kaikille tuotteille, jotka on tällä hetkellä linkitetty tähän kategoriaan',
    impact_error: 'Ei onnistuttu tarkistamaan, mihin tuotteisiin tämä vaikuttaisi',
    cancel: 'Peruuta',
    confirm: 'Vahvista',
  },
  toasts: {
    load_error: 'Verokategorioita ei voitu ladata.',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
    delete_error: 'Tätä verokategoriaa ei voitu poistaa.',
    category_deleted: 'Verokategoria poistettu',
    category_reset: 'Verokategoria palautettu perittyyn',
    reset_error: 'Tätä verokategoriaa ei voitu palauttaa.',
    impact_error: 'Ei onnistuttu tarkistamaan, mihin tuotteisiin tämä vaikuttaisi',
    impact_changed_one: 'Vaikutettujen tuotteiden määrä muuttui ({{count}}). Tarkista ja vahvista uudelleen.',
    impact_changed_other: 'Vaikutettujen tuotteiden määrä muuttui ({{count}}). Tarkista ja vahvista uudelleen.',
  },
};
